export default "__VITE_ASSET__C5wE65pv__"